import React from 'react';
import { useParams } from 'react-router-dom';
import { DataTableActions } from 'src/components/DataTable';
import { isModalComplete } from 'src/components/ModalDialog';
import { useModal } from 'src/hooks';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useSolutionUserRoles } from '../../hooks';
import { SolutionSourceImageRepositoryItem } from '../../types';
import { solutionsStore } from '../../index';
import SolutionSourceImageRepoEditContainer from './SolutionSourceImageRepoEditContainer';
import SolutionSourceImageRepoDeleteModal from './SolutionSourceImageRepoDeleteModal';

type Props = {
  item?: SolutionSourceImageRepositoryItem;
};

function SolutionSourceImageActions({ item }: Props) {
  const { solutionId } = useParams();
  const { isValidSolutionOwner } = useSolutionUserRoles(solutionId);
  const actions = useStoreUnitActions(solutionsStore);
  const onClose = (event, reason) =>
    isModalComplete(reason) && actions.subscriptions(solutionId);

  const [EditSourceImageRepoDialog, showEditSourceImageRepoDialog] = useModal(
    SolutionSourceImageRepoEditContainer,
    {
      item,
      onClose: (reason) =>
        isModalComplete(reason) && actions.details(solutionId),
    }
  );

  const [DeleteSourceImageRepoDialog, showDeleteSourceImageRepoDialog] =
    useModal(SolutionSourceImageRepoDeleteModal, {
      item,
      onClose: (reason) =>
        isModalComplete(reason) && actions.details(solutionId),
    });

  return (
    <DataTableActions
      canEdit={isValidSolutionOwner}
      canDelete={isValidSolutionOwner}
      onEdit={showEditSourceImageRepoDialog}
      onDelete={showDeleteSourceImageRepoDialog}
    >
      {DeleteSourceImageRepoDialog}
      {EditSourceImageRepoDialog}
    </DataTableActions>
  );
}

export default SolutionSourceImageActions;
